import { GoodsNutrientRegistModel } from './../vo/goods-nutrient-regist.model';
import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1107Model } from './../kymw1107.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品媒体別文字情報取得クラス
 *
 * @export RegistNutrientInfoService
 * @class RegistNutrientInfoService
 * @extends {PlessResponder}
 */
@Injectable()
export class RegistNutrientInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1107Model;
  private vo: GoodsNutrientRegistModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistNutrientInfoService
   */
  private getBody(): PlessRequest {
    const nutrientComponents = this.vo.nutrientComponentList
      .filter(nutrientComponent => !PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(nutrientComponent.nutritionalQuantity)))
      .map(nutrientComponent => ({
        condition: {
          NutritionalCode: nutrientComponent.nutritionalCode,
          NutritionalQuantity: nutrientComponent.nutritionalQuantity
        }
      }));

    return new PlessRequest({
      regist: {
        NutrienInfoParameter: {
          parameter: {
            PCode: this.vo.pCode,
            ItemCode: this.vo.itemCode,
            AnalysisSeqNo: this.vo.analysisSeqNo,
            AnalysisUnit: this.vo.analysisUnit,
            NutritionalNote: this.vo.nutrientNote
          }
        },
        NutrientComponentList: {
          combination: nutrientComponents
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistNutrientInfoService
   */
  execute(model: KYMW1107Model, vo: GoodsNutrientRegistModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registNutrientInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistNutrientInfoService
   */
  success(data: any): void {
    // サーバからの結果を元に、商品栄養成分情報データを更新する
    this.model.setResultData(data);
    // 当該分析連番の栄養成分情報を呼出元画面へ返却する
    this.model.kymw1107Component.updateParent();

    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
